"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/controllers/BaseWidgetController");
var helpers_1 = require("./helpers");
var routeParams_1 = require("./routeParams");
var settings_1 = require("../settings");
var getSettingsValues_1 = require("@wix/tpa-settings/dist/src/contexts/SettingsContext/getSettingsValues");
var utils_1 = require("@wix/social-groups-common/dist/src/utils");
var Controller = /** @class */ (function (_super) {
    tslib_1.__extends(Controller, _super);
    function Controller(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.goToGroupList = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupListPageRelativeUrl, location;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isEditorMode()) {
                            window.Wix.Utils.navigateToSection({
                                sectionId: utils_1.COMPONENT_ID.GROUP_LIST,
                                state: '',
                                queryParams: {},
                            }, console.error);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.controllerConfig.wixCodeApi.site.getSectionUrl({
                                sectionId: utils_1.COMPONENT_ID.GROUP_LIST,
                            })];
                    case 1:
                        groupListPageRelativeUrl = (_a.sent()).relativeUrl;
                        location = this.getLocation();
                        location.to(groupListPageRelativeUrl);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.groupId = groupId;
        return _this;
    }
    Controller.prototype.getLocation = function () {
        if (this.isEditorMode()) {
            return {
                navigateToSection: function () { return Promise.resolve(); },
                onChange: function () { },
                to: function () { },
                baseUrl: '',
                path: ['group', this.groupId, 'discussion'],
                query: {},
                queryParams: {
                    add: function () { },
                    remove: function () { },
                },
                url: '',
            };
        }
        return _super.prototype.getLocation.call(this);
    };
    Controller.prototype.getGroupId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupId, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.groupId) {
                            return [2 /*return*/, Promise.resolve(this.groupId)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, helpers_1.getGroupFromLocation(this.controllerConfig)];
                    case 2:
                        groupId = (_a.sent()).groupId;
                        this.groupId = groupId;
                        return [2 /*return*/, this.groupId];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Get Group id: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Controller.prototype.getFeedItemIdFromUrl = function () {
        var feedItemId = routeParams_1.groupRoute(this.getLocation()).feedItemId;
        return feedItemId;
    };
    Controller.prototype.bootstrapSettings = function (config) {
        var _a = tslib_1.__read([
            settings_1.textSettings,
            settings_1.generalLayoutSettings,
            settings_1.mediaLayoutSettings,
            settings_1.aboutDisplaySettings,
            settings_1.discussionsDisplaySettings,
            settings_1.mediaDisplaySettings,
            settings_1.membersDisplaySettings,
            settings_1.designSettings,
        ].map(function (settings) {
            return getSettingsValues_1.getSettingsValues(config.publicData.COMPONENT || {}, settings);
        }), 8), text = _a[0], generalLayout = _a[1], mediaLayout = _a[2], aboutDisplay = _a[3], discussionsDisplay = _a[4], mediaDisplay = _a[5], membersDisplay = _a[6], design = _a[7];
        return {
            text: text,
            generalLayout: generalLayout,
            mediaLayout: mediaLayout,
            aboutDisplay: aboutDisplay,
            discussionsDisplay: discussionsDisplay,
            mediaDisplay: mediaDisplay,
            membersDisplay: membersDisplay,
            design: design,
        };
    };
    return Controller;
}(BaseWidgetController_1.BaseWidgetController));
exports.Controller = Controller;
//# sourceMappingURL=Controller.js.map